import React from "react";
import PropTypes from "prop-types";
import TabMenu from "../../shared/tab-menu";
import TabGallery from "../../shared/tab-gallery";
import styles from "./style.css";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";

const GalleryTabs = ({
    setCurrentTabIndex,
    setGsGalleryDataConnect,
    tabs,
    activeTab
}) => {

    const renderButtonElement = (item) => {
        if (item && item.text) {
            return <span>{item.text}</span>;
        } else {
            return null;
        }
    };

    return (
        <div className={"container"}
            styleName={"styles.spinTabDiv"}>
            <TabMenu>
                {({ onClick }) => {
                    const onTabClickHandler = ({ index, type }) => {
                        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_DETAILS_IMAGE_GALLERY_VIEW, {
                            eventLabel: `Section selected ${type}`
                        });
                        setCurrentTabIndex(index);
                        setGsGalleryDataConnect({
                            activeTab: type,
                            isSpinCarLoaded: false
                        });
                        onClick({ index });
                    };

                    return (
                        <React.Fragment>
                            {tabs.map((item, index) => (
                                <TabGallery
                                    key={index}
                                    onClick={() =>
                                        onTabClickHandler({
                                            index,
                                            type: item.type,
                                            text: item.text
                                        })
                                    }
                                    //shouldCenter={true}
                                    element={renderButtonElement(item)}
                                    isActive={activeTab === item.type}
                                />
                            ))}
                        </React.Fragment>
                    );
                }}
            </TabMenu>
        </div>
    );
};

GalleryTabs.propTypes = {
    activeTab: PropTypes.string,
    setGsGalleryDataConnect: PropTypes.func,
    tabs: PropTypes.object,
    setCurrentTabIndex: PropTypes.number
};

export default GalleryTabs;
